import axiosInstance, { errorHandler } from "./api";
import { imageEncode } from "../util/imageEncoder";

const BankInfoAdapter = ({ phoneNumber, ...data }) => ({
  phone: phoneNumber,
  ...data,
});
// No permission (ParticipantBankResource.getParticipantBankInfoWeb)
const getBankInfo = axios => () =>
  axios
    .get(`/tps/api/participant-banks/web/info`)
    .then(({ data }) => {
      return BankInfoAdapter(data.data);
    })
    .catch(errorHandler);

// No permission (ParticipantBankResource.setParticipantBankInfo)
const setBankInfo = axios => data =>
  axios
    .post("/tps/api/participant-banks/info", {
      ...data,
    })
    .then(({ data }) => data)
    .catch(errorHandler);

// No permission (ParticipantBankResource.getBankLogoWrapped)
const getBankLogo = axios => id =>
  axios
    .get(`/tps/api/v2/participant-banks/logo/${id}`, {
      headers: {
        Accept: "image/png",
      },
      responseType: "arraybuffer",
    })
    .then(res => imageEncode(res.data, res.headers["content-type"]))
    .catch(errorHandler);

// No permission (ParticipantBankResource.getTitleLogo)
const getBankTitleLogo = axios => id =>
  axios
    .get(`/tps/api/v2/participant-banks/title-logo/${id}`, {
      headers: {
        Accept: "image/png",
      },
      responseType: "arraybuffer",
    })
    .then(res => imageEncode(res.data, res.headers["content-type"]))
    .catch(errorHandler);

export default {
  getBankInfo: getBankInfo(axiosInstance),
  setBankInfo: setBankInfo(axiosInstance),
  getBankLogo: getBankLogo(axiosInstance),
  getBankTitleLogo: getBankTitleLogo(axiosInstance),
};
